const devMode = process.env.REACT_APP_ENABLE_DEVELOPMENT_MODE || "false";

export const isDevMode = (): boolean => {
  return devMode === "true";
};
